module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-SemiBold.fe39a290.woff2";